exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".MuiBreadcrumbs-separator{margin-left:3px !important;margin-right:3px !important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/Common/Breadcrumb/Breadcrumb.scss
// module id = 1685
// module chunks = 101